import {CALL_API} from 'redux-api-middleware';
import {
  ENDPOINT_ACCOUNT,
  ENDPOINT_REGISTRATION,
  ENDPOINT_AUTH,
  ENDPOINT_LOGIN_GOV,
} from 'common/endpoints';
import {
  API_AUTH_LOGIN_REQUEST,
  API_AUTH_LOGIN_SUCCESS,
  API_AUTH_LOGIN_FAILURE,
  API_AUTH_REGISTER_REQUEST,
  API_AUTH_REGISTER_SUCCESS,
  API_AUTH_REGISTER_FAILURE,
  API_AUTH_LOGOUT_REQUEST,
  API_AUTH_LOGOUT_SUCCESS,
  API_AUTH_LOGOUT_FAILURE,
  LOGOUT,
  API_AUTH_REFRESH_REQUEST,
  API_AUTH_REFRESH_SUCCESS,
  API_AUTH_REFRESH_FAILURE,
  API_ACC_RESET_PW_REQUEST,
  API_ACC_RESET_PW_SUCCESS,
  API_ACC_RESET_PW_FAILURE,
  TOGGLE_TIMEOUT_MODAL,
  TOGGLE_PROFILE_UPDATE_MODAL,
  API_AUTH_TOKEN_LOADING_COMPLETE,
} from 'common/types';
import {getInfo} from 'common/storeUtils';
import goStore from 'go/store';
import {TOKEN_LOADED} from 'app-ui-componentlibrary/dist/common/constants';
import {commonJwtHeader} from 'common/utils';

export default {
  login: (username, password) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_AUTH}pw/login`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'cache-control': 'no-cache',
          pragma: 'no-cache',
        },
        body: JSON.stringify({username, password}),
        types: [
          API_AUTH_LOGIN_REQUEST,
          API_AUTH_LOGIN_SUCCESS,
          {
            type: API_AUTH_LOGIN_FAILURE,
            payload: (action, state, res) => {
              if (res) {
                return {
                  status: res.status,
                  statusText: res.statusText,
                  response: res.json(),
                };
              } else {
                return {
                  status: 'Network request failed',
                };
              }
            },
          },
        ],
      },
    };
  },
  disableCookie: () => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_AUTH}pw/logout`,
        method: 'POST',
        types: [
          API_AUTH_LOGOUT_REQUEST,
          API_AUTH_LOGOUT_SUCCESS,
          API_AUTH_LOGOUT_FAILURE,
        ],
      },
    };
  },
  // create account password for the first time
  completeAccount: (username, password, firstName, lastName, phoneNumbers, token) => ({
    [CALL_API]: {
      endpoint: `${ENDPOINT_ACCOUNT}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'cache-control': 'no-cache',
        pragma: 'no-cache',
      },
      body: JSON.stringify({
        username: username,
        password: password,
        firstName: firstName,
        lastName: lastName,
        phoneNumbers: phoneNumbers,
        token: token,
      }),
      types: [API_AUTH_LOGIN_REQUEST, API_AUTH_LOGIN_SUCCESS, API_AUTH_LOGIN_FAILURE],
    },
  }),
  // update profile for new login gov user.
  completeLGUserAccount: (firstName, lastName) => ({
    [CALL_API]: {
      endpoint: `${ENDPOINT_LOGIN_GOV + 'userProvided'}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'cache-control': 'no-cache',
        pragma: 'no-cache',
      },
      body: JSON.stringify({
        firstName: firstName,
        lastName: lastName,
      }),
      types: [API_AUTH_LOGIN_REQUEST, API_AUTH_LOGIN_SUCCESS, API_AUTH_LOGIN_FAILURE],
    },
  }),
  // send new password to server
  updatePW: (username, password, token) => ({
    [CALL_API]: {
      endpoint: `${ENDPOINT_ACCOUNT + encodeURIComponent(username) + `/password`}`,
      method: `${'PUT'}`,
      headers: {
        'Content-Type': 'application/json',
        'cache-control': 'no-cache',
        pragma: 'no-cache',
      },
      body: JSON.stringify({
        username: username,
        password: password,
        token: token,
      }),
      types: [API_AUTH_LOGIN_REQUEST, API_AUTH_LOGIN_SUCCESS, API_AUTH_LOGIN_FAILURE],
    },
  }),
  resetPW: (email) => ({
    [CALL_API]: {
      endpoint: `${ENDPOINT_ACCOUNT + encodeURIComponent(email) + `/password/reset`}`,
      method: 'PUT',
      body: JSON.stringify({
        email: email,
      }),
      types: [
        API_ACC_RESET_PW_REQUEST,
        API_ACC_RESET_PW_SUCCESS,
        API_ACC_RESET_PW_FAILURE,
      ],
    },
  }),
  refresh: () => refreshFromCookie(),
  register: (email, recaptchaToken) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_REGISTRATION}`,
        headers: {
          'Content-Type': 'application/json',
          'cache-control': 'no-cache',
          pragma: 'no-cache',
        },
        method: 'POST',
        body: JSON.stringify({email, recaptchaToken}),
        types: [
          API_AUTH_REGISTER_REQUEST,
          API_AUTH_REGISTER_SUCCESS,
          API_AUTH_REGISTER_FAILURE,
        ],
      },
    };
  },
  logout: () => ({type: LOGOUT}),
  toggleTimeoutModal: (payload) => ({
    type: TOGGLE_TIMEOUT_MODAL,
    payload: payload,
  }),
  toggleProfileUpdateModal: (payload) => ({
    type: TOGGLE_PROFILE_UPDATE_MODAL,
    payload: payload,
  }),
};

export function loginUserSuccess(token) {
  return {
    type: API_AUTH_LOGIN_SUCCESS,
    payload: {
      token: token,
    },
  };
}

export function loginCSRFUserSuccess(payload) {
  return {
    type: API_AUTH_LOGIN_SUCCESS,
    payload: {
      _csrftoken: payload._csrftoken,
      permissions: payload.permissions,
      generalPermissions: payload.generalPermissions,
    },
  };
}

export function refreshFromCookie() {
  return {
    [CALL_API]: {
      endpoint: `${ENDPOINT_AUTH}token/refresh`,
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      method: 'POST',
      types: [
        API_AUTH_REFRESH_REQUEST,
        API_AUTH_REFRESH_SUCCESS,
        API_AUTH_REFRESH_FAILURE,
      ],
    },
  };
}

export const completeTokenLoading = () => ({
  type: API_AUTH_TOKEN_LOADING_COMPLETE,
});
